<div>
    <div class="card">
        <div class="card-header py-3 bg-transparent border-bottom-0">
            <mat-button-toggle-group name="CompraVentaToggle" aria-label="Font Style" style="height: 35px;" (change)="onCompraVentaToggle($event.value)" [value]="selectedToggle">
                <mat-button-toggle value="COMPRA" style="width: 100px; height: 35px;">Compra</mat-button-toggle>
                <mat-button-toggle value="VENTA" style="width: 100px; height: 35px;">Venta</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    
        <div class="card-body">
            <form class="row g-3 d-flex justify-content-start">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <label class="col-form-label">Periodos</label>
                    <select class="form-select array-select form-control" #periodosSelect (change)="onSelectedPeriodo(periodosSelect.value)">
                        <!-- QUE TOME EL AÑO ACTUAL Y LE RESTE -->
                        
                        <option *ngFor="let periodo of periodos" [value]="periodo.display">{{ periodo.display }}</option>
                    </select>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 d-flex align-items-end pb-1">
                    <button type="button" class="btn btn-white border lift" (click)="onRefresh()">
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>
            </form>
        </div>
    
    </div>
    
    <div class="mt-5">
        <app-loader-w-message *ngIf="loadingReport" loadingMessage="Obteniendo reporte"></app-loader-w-message>
    </div>


    <div *ngIf="!loadingReport && !loadFailed">
        <!-- TILES -->
        <!-- SON 3 -->
        <app-totalizer-tiles [tiles]="selectedTiles" [selectedToggle]="selectedToggle"></app-totalizer-tiles>
    
        <!-- GRAFICO DE BARRAS -->
        <app-lcv-ev-column-chart [chartOptions]="evChartOptions" [selectedToggle]="selectedToggle"></app-lcv-ev-column-chart>
        
        <!-- ESTADISTICOS -->
        <app-lcv-stats [totalStats]="totalStats" [selectedToggle]="selectedToggle"></app-lcv-stats>
        
        <!-- TABLA PROVEEDORES/CLIENTES -->
        <!-- REVISAR PERIODO PARA LA TABLA -->
        <app-lcv-proveedores-table *ngIf="showTable" [selectedToggle]="selectedToggle" [periodoInicial]="getStarYearOfPeriod(periodoSelectedObject)" [meses]="getMesesPeriodoActual()" [cantidadRegistrosVenta]="cantidadRegistrosVenta" [cantidadRegistrosCompra]="cantidadRegistrosCompra"></app-lcv-proveedores-table>
        
        <!-- GRAFICOS DE TORTA POR PROPIEDAD -->
        <app-lcv-by-property-charts [chartOptionsYear]="pieChartYear" [chartOptionsType]="pieChartType" [selectedToggle]="selectedToggle"></app-lcv-by-property-charts>
        
        <!-- TOP 10 -->
        <app-lcv-top10 [top10List]="top10List" [selectedToggle]="selectedToggle"></app-lcv-top10>
        
        <!-- EVOLUTIVO POR PROVEEDOR/CLIENTE -->
        <app-lcv-ev-by-entity [evChartOptions]="evByEntity" [selectedToggle]="selectedToggle"></app-lcv-ev-by-entity>
    </div>
</div>